import React from 'react'
import throttle from 'lodash/throttle'
import { Carousel, Icon, Pagination, Modal } from 'antd'
import { ComponentExt } from 'util/reactExt'
import { Year as Cate } from 'components/layout/CateLayout'
import StarPanel from 'components/StarPanel'
import WorkPanel from 'containers/shared/WorkPanel'
import { RouteComponentProps } from 'react-router'
// import rewardImg from 'assets/images/reward.jpg'
import newHeroImg from 'assets/images/new_hero.png'
import workbg from 'assets/images/year_bg2.png'
import * as styles from './index.scss'
import Menus from '../components/Menus'

interface IProps extends RouteComponentProps<any> {}
interface IState {
  type: string
  tabs: string[]
  tabIndex: string
  banner: any[]
  rewardModal: boolean
  anchor: number
  list1: { data: any[]; total: number }
  list2: { data: any[]; total: number }
  list3: { data: any[]; total: number }
  list4: { data: any[]; total: number }
  list5: { data: any[]; total: number }
  list6: { data: any[]; total: number }
  pageindex1: number
  pageindex2: number
  pageindex3: number
  pageindex4: number
  pageindex5: number
  pageindex6: number
}

class YearHero extends ComponentExt<IProps, IState> {
  private doms: HTMLElement[] = Array(5).fill(undefined)
  constructor(props: IProps) {
    super(props)
    this.state = {
      type: '',
      tabs: [],
      tabIndex: '',
      banner: [],
      rewardModal: false,
      anchor: 0,
      list1: { data: [], total: 0 },
      list2: { data: [], total: 0 },
      list3: { data: [], total: 0 },
      list4: { data: [], total: 0 },
      list5: { data: [], total: 0 },
      list6: { data: [], total: 0 },
      pageindex1: 1,
      pageindex2: 1,
      pageindex3: 1,
      pageindex4: 1,
      pageindex5: 1,
      pageindex6: 1,
    }
  }

  componentDidMount() {
    const { search } = this.props.location
    const type = new URLSearchParams(search).get('type')
    this.getYear(type)
    if (type) {
      this.setState({
        type,
        tabIndex: type,
      })
      this.fetchFirstList(type)
      this.fetchBanner(type)
    }
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  setStateAsync(state) {
    return new Promise(resolve => {
      this.setState(state, resolve)
    })
  }

  async fetchBanner(year) {
    try {
      const data = await this.api.hero.getYearList(
        { pageindex: 1 },
        6200100,
        year,
      )
      this.setState({
        banner: data,
      })
    } catch (err) {
      console.error(err)
    }
  }

  async fetchFirstList(year) {
    return Array(6)
      .fill('')
      .map(async (_, idx) => {
        try {
          const data = await this.getList(
            6200100 + idx + 1,
            year,
            1,
            idx > 2 ? (idx === 4 ? 5 : 3) : 9,
          )
          await this.setStateAsync({
            [`list${idx + 1}`]: data,
          } as any)
        } catch (err) {
          console.error(err)
        }
      })
  }

  async fetchList(idx, page, size) {
    const { type } = this.state
    const data = await this.getList(6200100 + idx, type, page, size)
    this.setState({
      [`list${idx}`]: data,
    } as any)
  }

  async getYear(type?) {
    try {
      const data = await this.api.hero.getYear()
      if (data.length) {
        this.setState({
          tabs: data.reverse(),
          tabIndex: type || data[0],
          type: type || data[0],
        })
        if (!type) {
          this.fetchFirstList(data[0])
          this.fetchBanner(data[0])
        }
      }
    } catch (err) {
      console.error(err)
    }
  }

  async getList(type, year, pageindex = 1, pagesize = 3) {
    const { data, total } = await this.api.hero.getYearList(
      { pageindex, pagesize },
      type,
      year,
    )
    return { data, total }
  }

  handleScroll = throttle(() => {
    const nodes = this.doms.map(e => e.offsetTop - 20)
    const sct = document.documentElement.scrollTop
    this.setState({
      anchor: this.find(sct, nodes),
    })
  }, 200)

  find = (n, arr, i = 0) =>
    n < arr[0]
      ? 0
      : arr[i] > n
      ? i - 1
      : i !== arr.length
      ? this.find(n, arr, i + 1)
      : 5

  handleNav = idx =>
    window.scrollTo({
      top: idx === 0 ? 0 : this.doms[idx].offsetTop,
      behavior: 'smooth',
    })

  cancelModal = () => this.setState({ rewardModal: false })

  tabChange = idx => {
    const { history, location } = this.props
    history.replace({
      pathname: location.pathname,
      search: `type=${idx}`,
    })
    this.setState({
      tabIndex: idx,
    })
    this.fetchFirstList(idx)
  }

  pageChange = (mo, page) => {
    const size = mo > 2 ? (mo === 5 ? 5 : 3) : 9
    this.setState({
      [`pageindex${mo}`]: page,
    } as any)
    this.fetchList(mo, page, size)
  }

  showReward = () =>
    this.setState({
      rewardModal: true,
    })

  handleClick = (id, type) => window.open(`#/course/${id}?type=${type}`)

  renderKing(info) {
    return (
      <div className={styles.newKing}>
        <div className={styles.newKingAvatar}>
          <div
            style={{
              backgroundImage: `url(${info.img})`,
              backgroundPosition: 'top center',
              backgroundSize: '100%',
            }}
          />
          <img src={newHeroImg} />
        </div>
        <div className={styles.newKingBody}>
          <div className={styles.newKingName}>
            <span>{info.staff_name || ''}</span>
          </div>
          <div className={styles.newKingTag}>{info.entity_name || ''}</div>
          <div className={styles.newKingTell} title={info.tzxy}>
            {info.tzxy || ''}
          </div>
          <div className={styles.newKingDesc} title={info.desc}>
            {info.desc || ''}
          </div>
          <div
            className={styles.newKingBtn}
            style={{
              opacity: !info.article_id && 0.5,
              cursor: !info.article_id && 'no-drop',
            }}
            onClick={() =>
              info.article_id &&
              this.handleClick(info.article_id, info.article_type)
            }
          >
            成长故事
            <Icon type="right" />
          </div>
        </div>
      </div>
    )
  }

  render() {
    const {
      tabs,
      tabIndex,
      list1,
      list2,
      list3,
      list4,
      list5,
      list6,
    } = this.state

    const RewardModal = () => (
      <Modal
        title="奖励机制"
        width={800}
        onCancel={this.cancelModal}
        footer={false}
        visible={this.state.rewardModal}
      >
        <div className={styles.yearheroModalImg}>
          {/* <img src={rewardImg} /> */}
        </div>
      </Modal>
    )
    const navibar = () => {
      return (
        <div className={styles.navibar}>
          {[
            '年度\n新人王',
            // '最佳大区',
            '最佳团队',
            '最佳合规团队',
            '最佳职业\n经理人',
            '金牌投顾',
            '十佳精英',
          ].map((v, i) => (
            <div
              key={`nav${i}`}
              onClick={() => this.handleNav(i)}
              className={
                i === this.state.anchor
                  ? styles.navibarItemLight
                  : styles.navibarItem
              }
              dangerouslySetInnerHTML={{ __html: v.replace('\n', '<br>') }}
            />
          ))}
        </div>
      )
    }
    const menus = () => {
      return (
        <div className={styles.menu} key="menu">
          <Menus key="menu" defaultKey="yearhero" />
        </div>
      )
    }
    return (
      <div className={styles.wrapper}>
        {menus()}
        <section>
          <div className={styles.yearheroGroup}>
            <div>
              {tabs.map((v, i) => (
                <span
                  className={
                    tabIndex === v
                      ? styles.yearheroGroupItemLight
                      : styles.yearheroGroupItem
                  }
                  key={i}
                  onClick={() => this.tabChange(v)}
                >
                  {v}年
                </span>
              ))}
            </div>
            <div
              className={styles.yearheroGroupCrown}
              onClick={this.showReward}
            >
              <Icon type="gift" style={{ fontSize: 24 }} />
              <span>奖励机制</span>
            </div>
          </div>
          <div
            className={styles.yearheroKing}
            ref={node => (this.doms[0] = node)}
          >
            <div style={{ paddingBottom: 12, width: '100%', maxWidth: 1200 }}>
              {!!list1.data.length && (
                <Carousel autoplaySpeed={5000} autoplay>
                  {list1.data.map((item, idx) => (
                    <div key={`new${idx}`}>{this.renderKing(item)}</div>
                  ))}
                </Carousel>
              )}
            </div>
          </div>
          {/* <div ref={node => (this.doms[1] = node)}>
            {!!this.state.banner.length && tabIndex === '2017' && (
              <Cate title="最佳大区" odd>
                <div className={styles.yearheroKing}>
                  <img src={this.state.banner[0].img_url} />
                  <div
                    className={styles.newKingBtn}
                    style={{
                      opacity: 0.5,
                      cursor: 'no-drop',
                    }}
                    // onClick={() =>
                    //   info.article_id &&
                    //   this.handleClick(info.article_id, info.article_type)
                    // }
                  >
                    成长故事
                    <Icon type="right" />
                  </div>
                </div>
              </Cate>
            )}
          </div> */}
          <div ref={node => (this.doms[1] = node)}>
            {!!list2.data.length && (
              <Cate title="最佳团队">
                <div
                  style={{
                    width: '100%',
                    padding: 12,
                    maxWidth: 1200,
                    backgroundColor: '#505053',
                    backgroundImage: `url(${workbg})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: '100%',
                  }}
                >
                  <WorkPanel list={list2.data} />
                </div>
              </Cate>
            )}
          </div>
          <div ref={node => (this.doms[2] = node)}>
            {!!list6.data.length && (
              <Cate title="最佳合规团队">
                <div
                  style={{
                    width: '100%',
                    padding: 12,
                    maxWidth: 1200,
                    backgroundColor: '#505053',
                    backgroundImage: `url(${workbg})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: '100%',
                  }}
                >
                  <WorkPanel list={list6.data} />
                </div>
              </Cate>
            )}
          </div>
          <div ref={node => (this.doms[3] = node)}>
            {!!list3.data.length && (
              <Cate title="最佳职业经理人" odd>
                <div style={{ width: '100%' }}>
                  <WorkPanel list={list3.data.slice(0, 6)} people />
                </div>
              </Cate>
            )}
          </div>
          <div ref={node => (this.doms[4] = node)}>
            {!!list4.data.length && (
              <Cate title="金牌投顾">
                <div className={styles.yearheroWrapper3}>
                  {list4.data.map(
                    (
                      {
                        article_id,
                        article_type,
                        staff_name,
                        entity_name,
                        img,
                        desc,
                      },
                      idx,
                    ) => (
                      <div key={idx}>
                        <StarPanel.Year
                          key={`yp${idx}`}
                          id={article_id}
                          cover={img}
                          name={staff_name}
                          region={entity_name}
                          desc={desc}
                          onClick={() =>
                            this.handleClick(article_id, article_type)
                          }
                        />
                      </div>
                    ),
                  )}
                </div>
              </Cate>
            )}
          </div>
          <div ref={node => (this.doms[5] = node)}>
            {!!list5.data.length && (
              <Cate title="十佳精英" odd>
                <div className={styles.yearheroWrapper5}>
                  {list5.data.map(
                    (
                      {
                        article_id,
                        article_type,
                        staff_name,
                        entity_name,
                        img,
                        desc,
                      },
                      idx,
                    ) => (
                      <div key={idx}>
                        <StarPanel.Year
                          key={`yp${idx}`}
                          id={article_id}
                          cover={img}
                          name={staff_name}
                          region={entity_name}
                          desc={desc}
                          onClick={() =>
                            this.handleClick(article_id, article_type)
                          }
                          small
                        />
                      </div>
                    ),
                  )}
                </div>
                <div style={{ textAlign: 'center', width: '100%' }}>
                  <Pagination
                    total={this.state.list5.total}
                    current={this.state.pageindex5}
                    onChange={page => this.pageChange(5, page)}
                    defaultPageSize={5}
                  />
                </div>
              </Cate>
            )}
          </div>
        </section>
        {RewardModal()}
        {navibar()}
      </div>
    )
  }
}

export default YearHero
